module.exports = __webpack_public_path__ + "img/product-ketang-kjxl-02.974e8b75.png";